import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { 
  FaPhoneAlt, 
  FaEnvelope, 
  FaFacebookF, 
  FaInstagram,
  FaGoogle,  
  FaChevronDown, 
  FaChevronUp, 
  FaTimes,
} from "react-icons/fa";
import "../CSS/Header.css";
import logo from "../Assets/logo.png"; // Adjust the path based on your folder structure


export default function PremiumHeader() {
  const [panelOpen, setPanelOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  // Close panel on Escape key
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") closePanel();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  // Prevent scrolling when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = panelOpen ? "hidden" : "";
  }, [panelOpen]);

  const togglePanel = (e) => {
    if (e) e.stopPropagation();
    setPanelOpen((p) => !p);
    setOpenDropdown(null);
  };

  const closePanel = () => {
    setPanelOpen(false);
    setOpenDropdown(null);
  };

  const toggleDropdown = (key, e) => {
    if (e) e.stopPropagation();
    setOpenDropdown((prev) => (prev === key ? null : key));
  };

  const navItems = [
    { title: "Home", path: "/", type: "link" },
    { title: "About Us", path: "/about", type: "link" },
    {
      title: "Services",
      type: "dropdown",
      items: [
        { title: "All Services", path: "/services" },
        { title: "Personal Document Apostille", path: "/services/personal" },
        { title: "Commercial Document Apostille", path: "/services/commercial" },
        { title: "Apostille Service in Mumbai", path: "/services/apostillemumbai" },
        { title: "Document Translation", path: "/services/document-translation" },
        { title: "Visa & FRRO Services", path: "/services/visa-services" },
      ],
    },
    { title: "Apostille Online", path: "/apostille-online", type: "link" },

    // {
    //   title: "Blogs",
    //   type: "dropdown",
    //   items: [
    //     { title: "All Blogs", path: "/blogs" },
    //     { title: "Apostille Attestation", path: "/blog/apostille-attestation" },
    //     { title: "GK Scholarship", path: "/blog/gksscholarship" },
    //   ],
    // },
    {
      title: "Useful Links",
      type: "dropdown",
      items: [
        { title: "Useful Links", path: "/useful-links" },
        { title: "Apostille", path: "/apostille" },
        { title: "FAQs", path: "/faq" },
        // { title: "MEA approved list of university", path: "/mea-approved-university-list" },
      ],
    },
    { title: "Blogs", path: "/blog", type: "link" },
    // {
    //   title: "Resource",
    //   type: "dropdown",
    //   items: [
    //     { title: "All Resources", path: "/resources" },
    //     { title: "Document Apostille", path: "/resources/document-apostille" },
    //     { title: "Hague Apostille Country List", path: "/resources/hague-list" },
    //   ],
    // },
    { title: "Contact Us", path: "/contact", type: "link" },
  ];

const socialLinks = [
  { 
    icon: <FaFacebookF />, 
    url: "https://www.facebook.com/share/16NNZyRcD2/", 
    label: "Facebook" 
  },
  { 
    icon: <FaInstagram />, 
    url: "https://www.instagram.com/pandey_associate_/", 
    label: "Instagram" 
  },
  { 
    icon: <FaGoogle />, 
    url: "https://share.google/T7BzfGzccGuc7VJvr", // Replace with your actual GMB link
    label: "Google My Business" 
  },
];

  return (
    <header className="ph-header" role="banner">
      {/* Top Bar - Contact and Social */}
      <div className="ph-top-bar">
        <div className="ph-top-container">
          <div className="ph-contact-info">
            <a href="tel:+916393244687" className="ph-contact-item">
              <FaPhoneAlt className="ph-icon-gold" /> +91-6393244687
            </a>
            <a href="mailto:info@apostilleserviceinmumbai.com" className="ph-contact-item ph-hide-mobile">
              <FaEnvelope className="ph-icon-gold" /> info@apostilleserviceinmumbai.com
            </a>
          </div>
          <div className="ph-social-icons">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.label}
                className="ph-social-link"
              >
                {social.icon}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Main Bar */}
      <div className="ph-main-bar">
        <div className="ph-logo">
  <Link to="/" onClick={closePanel} className="ph-logo-link">
    <img src={logo} alt="Pandey & Associates Logo" className="ph-logo-img" />
  </Link>
</div>

        {/* Desktop Navigation */}
        <nav className="ph-nav-desktop" aria-label="Main navigation">
          <ul className="ph-desktop-list">
            {navItems.map((item, index) => {
              if (item.type === "link") {
                return (
                  <li key={index}>
                    <Link to={item.path} className="ph-desktop-link">
                      {item.title}
                    </Link>
                  </li>
                );
              } else if (item.type === "dropdown") {
                return (
                  <li key={index} className="ph-desktop-dropdown">
                    <button className="ph-desktop-link ph-desktop-parent" aria-haspopup="true">
                      {item.title} <FaChevronDown className="ph-chevron" />
                    </button>
                    <div className="ph-desktop-menu" role="menu">
                      <ul className="ph-dropdown-inner-list">
                        {item.items.map((sub, subIndex) => (
                          <li key={subIndex}>
                            <Link to={sub.path} role="menuitem">
                              {sub.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </li>
                );
              }
              return null;
            })}
          </ul>
        </nav>

        {/* Hamburger Menu Icon */}
        <div className="ph-right">
          <button
            className={`ph-hamburger ${panelOpen ? "open" : ""}`}
            aria-label={panelOpen ? "Close menu" : "Open menu"}
            aria-expanded={panelOpen}
            onClick={togglePanel}
          >
            <span className="ph-hamburger-inner"></span>
          </button>
        </div>
      </div>

      {/* Mobile Overlay */}
      <div
        className={`ph-overlay ${panelOpen ? "open" : ""}`}
        onClick={closePanel}
        aria-hidden={!panelOpen}
      />

      {/* Mobile Sidebar Panel */}
      <aside className={`ph-panel ${panelOpen ? "open" : ""}`} aria-hidden={!panelOpen}>
        <div className="ph-panel-inner">
          <div className="ph-panel-header">
  <div className="ph-panel-logo">
    <Link to="/" onClick={closePanel} className="ph-sidebar-logo-link">
      <img src={logo} alt="Pandey & Associates Logo" className="ph-sidebar-logo-img" />
    </Link>
    <span className="ph-tagline">Adv. Neeraj Pandey</span>
  </div>
  <button className="ph-panel-close" onClick={closePanel} aria-label="Close menu">
    <FaTimes />
  </button>
</div>

          <nav className="ph-panel-nav" aria-label="Mobile navigation">
            <ul className="ph-panel-list">
              {navItems.map((item, index) => {
                if (item.type === "link") {
                  return (
                    <li key={index}>
                      <Link to={item.path} onClick={closePanel}>
                        {item.title}
                      </Link>
                    </li>
                  );
                } else if (item.type === "dropdown") {
                  return (
                    <li key={index} className="ph-accordion">
                      <button
                        className="ph-acc-btn"
                        onClick={(e) => toggleDropdown(item.title, e)}
                      >
                        <span>{item.title}</span>
                        <span className="ph-acc-caret">
                          {openDropdown === item.title ? <FaChevronUp /> : <FaChevronDown />}
                        </span>
                      </button>
                      <ul className={`ph-acc-panel ${openDropdown === item.title ? "open" : ""}`}>
                        {item.items.map((sub, subIndex) => (
                          <li key={subIndex}>
                            <Link to={sub.path} onClick={closePanel}>
                              {sub.title}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </li>
                  );
                }
                return null;
              })}
              
              {/* Sidebar Contact Block */}
              <li className="ph-panel-contact">
                <a href="tel:+916393244687"><FaPhoneAlt /> +91-6393244687</a>
                <a href="mailto:info@apostilleserviceinmumbai.com"><FaEnvelope /> info@apostilleserviceinmumbai.com</a>
              </li>
              
              {/* Sidebar Social Icons */}
              <li className="ph-panel-social">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ph-panel-social-link"
                  >
                    {social.icon}
                  </a>
                ))}
              </li>
            </ul>
          </nav>
        </div>
      </aside>
    </header>
  );
}